import { useParams } from "react-router-dom"
import Footer from "../../components/footer/Footer"
import Navbar from "../../components/navbar/Navbar"
import styled from "./createArticle.module.css"
import { useEffect, useState } from "react"
import axios from "axios"
import Input from "../../components/input/Input"
import Textarea from "../../components/textarea/Textarea"
function CreateArticle(){
  
    const [article, setArticle]=useState({
        imgUrl:"",
        title:"",
        readingTime:"",
        date:"",
        autor:"",
        content:"",
      
    

    }) ;
   
    const handleChangeArticle= (e) =>{
        setArticle((prevState)=>({
            ...prevState,
            [e.target.name]: e.target.value,

        }));
    };
    const handleChangeArticleMessage= (e) =>{
        setArticle((prevState)=>({
            ...prevState,
            content: e.target.value,

        }));
    };
  const handleCreateNewArticle = () => {};
   
       
     
     console.log(article);
    // const reduceToCounter=()=>{
    //     setCounter(counter-1)
    // }
   return(

    <>
    <Navbar title="سایت عوض نیا" />
        <div className={styled.CreateArticlePage} >
        <div className="container">
            <h1>ساخت مقاله</h1>
            <Input label="عنوان" name="title" handleChange={handleChangeArticle} type="text"/>
            <Input label="تاریخ" name="date" handleChange={handleChangeArticle} type="text"/>
            <Input label="مدت زمان خواندن" name="readingTime" handleChange={handleChangeArticle} type="text"/>
            <Input label="نویسنده" name="autor" handleChange={handleChangeArticle} type="text"/>
            <Input label="آدرس عکس" name="imgUrl" handleChange={handleChangeArticle} type="text"/>

           <Textarea label="متن"  name="content" handleChange={handleChangeArticleMessage}/>

        <div className={styled.buttonWrapper}>
            <button onClick={handleCreateNewArticle}>ساخت مقاله</button>
        </div>
        </div>
        </div>

    </>
           
);

}

export default CreateArticle;
